
define('ldsh!modules/lp_info/templates/page_line_empty', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<span>No hay ninguna landing donde copiar</span>\n';

}
return __p
};});

